enum ChargingConnectorColor {
    STATUS_COLOR_DANGER = 'text-color-danger',
    STATUS_COLOR_GRAYED_OUT = 'text-color-gray',
    STATUS_COLOR_SUCCESS = 'text-color-success',
    STATUS_COLOR_WARNING = 'text-color-warning',
}

export default ChargingConnectorColor;
